import { BookText, Building2, type LucideIcon, MapPin, User } from 'lucide-react'

import type { BookAiTerm } from '@/api/services/book-ai'

export type GlossaryKind = BookAiTerm['kind']

/** 人物・用語の種類ごとの見出し・アイコン・色（この順に並べる） */
// color は相関図（SVG）で塗る色。className と同じ色味にする
export const GLOSSARY_KINDS: {
  kind: GlossaryKind
  label: string
  icon: LucideIcon
  className: string
  color: string
}[] = [
  {
    kind: 'person',
    label: '人物',
    icon: User,
    className: 'bg-sky-500/15 text-sky-600 dark:text-sky-300',
    color: '#0ea5e9',
  },
  {
    kind: 'term',
    label: '用語',
    icon: BookText,
    className: 'bg-violet-500/15 text-violet-600 dark:text-violet-300',
    color: '#8b5cf6',
  },
  {
    kind: 'place',
    label: '場所',
    icon: MapPin,
    className: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-300',
    color: '#10b981',
  },
  {
    kind: 'organization',
    label: '組織',
    icon: Building2,
    className: 'bg-amber-500/15 text-amber-600 dark:text-amber-300',
    color: '#f59e0b',
  },
]

/** 種類の設定（AI が想定外の種類を返したときは用語として扱う） */
export const glossaryKindConfig = (kind: string) => GLOSSARY_KINDS.find((k) => k.kind === kind) ?? GLOSSARY_KINDS[1]
